// API
export const EXPORT_BARKER_CHANNEL_API = 'cognito/barkerchannel/:uuid/export';
